"use strict";
/**
 * API Response Types for Helpasaur King
 * These types define the standardized response format used across all API endpoints
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayEvent = exports.ApiResult = exports.COMMAND_EDIT_PERMISSIONS = exports.hasAnyPermission = exports.Permission = void 0;
// Permission Types
var Permission;
(function (Permission) {
    Permission["ADMIN"] = "admin";
    Permission["SERVICE"] = "service";
    Permission["COMMAND_MANAGER"] = "command_manager";
})(Permission || (exports.Permission = Permission = {}));
const hasAnyPermission = (userPermissions, requiredPermissions) => {
    return requiredPermissions.some((p) => userPermissions.includes(p));
};
exports.hasAnyPermission = hasAnyPermission;
exports.COMMAND_EDIT_PERMISSIONS = [
    Permission.ADMIN,
    Permission.COMMAND_MANAGER,
];
var ApiResult;
(function (ApiResult) {
    ApiResult["SUCCESS"] = "success";
    ApiResult["ERROR"] = "error";
    ApiResult["NOOP"] = "noop";
})(ApiResult || (exports.ApiResult = ApiResult = {}));
// WebSocket Relay Event Types
var RelayEvent;
(function (RelayEvent) {
    RelayEvent["STREAM_ALERT"] = "streamAlert";
    RelayEvent["WEEKLY_RACE_ROOM_CREATED"] = "weeklyRaceRoomCreated";
    RelayEvent["JOIN_TWITCH_CHANNEL"] = "joinChannel";
    RelayEvent["LEAVE_TWITCH_CHANNEL"] = "leaveChannel";
    RelayEvent["TWITCH_BOT_CONFIG_UPDATED"] = "twitchBotConfigUpdated";
})(RelayEvent || (exports.RelayEvent = RelayEvent = {}));
//# sourceMappingURL=api.js.map